import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';
import { TPermissionChecksState } from './types';

export default {
  namespaced: true,
  state: (): TPermissionChecksState => ({
    checks: {},
  }),
  getters,
  mutations,
  actions,
};
